import { formatCount, properties, scoreLabel } from '../data';
import SearchForm from './SearchForm';

function StayGrid({ title, items, onOpen }) {
  return (
    <section className="section">
      <h2>{title}</h2>
      <div className="stay-grid">
        {items.map((p) => (
          <button key={p.id} className="stay-card" onClick={() => onOpen(p)}>
            <img src={p.images[0]} alt="" />
            <div className="stay-card-body">
              <h3>{p.name}</h3>
              <p>{p.city} · {scoreLabel(p.score)} {p.score}</p>
              <span>{formatCount(p.reviews)} reviews</span>
            </div>
          </button>
        ))}
      </div>
    </section>
  );
}

export default function HomePage({ onOpenProperty, search, setSearch, onSearch }) {
  const available = properties.slice(0, 4);
  const booked = properties.filter((p) => p.popular).slice(0, 4);

  return (
    <>
      <section className="hero">
        <div className="hero-media">
          <img className="hero-photo" src="/img/moja.jpeg" alt="Kaya Serene Villa" />
          <div className="hero-shade" />
        </div>
        <div className="wrap hero-inner">
          <p className="hero-kicker">Karibu</p>
          <h1>Homes by the water, and just inland.</h1>
          <p>Furnished apartments at Kaya Serene Villa, Dar es Salaam.</p>
          <SearchForm search={search} setSearch={setSearch} onSearch={onSearch} />
        </div>
      </section>

      <div className="page">
        <div className="wrap">
          <StayGrid title="Available Apartments" items={available} onOpen={onOpenProperty} />
          <StayGrid title="Most booked apartments this month" items={booked} onOpen={onOpenProperty} />
        </div>
      </div>
    </>
  );
}
